import SingleChooser from './SingleChooser';

export default SingleChooser;
